// src/pages/Onboard/StepFinal.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function StepFinal({ name = "", waitMs = 0 }) {
  const navigate = useNavigate();

  useEffect(() => {
    let t;
    (async () => {
      try {
        const mod = await import("canvas-confetti");
        mod.default({ particleCount: 180, spread: 80, origin: { y: 0.6 } });
        setTimeout(() => mod.default({ particleCount: 120, spread: 70, origin: { y: 0.6 } }), 800);
      } catch {}
      if (waitMs > 0) t = setTimeout(() => navigate("/seller/dashboard"), waitMs);
    })();
    return () => t && clearTimeout(t);
  }, [navigate, waitMs]);

  return (


 <div className="onboard-wrapper">
    <div className="onboard-card">



    <section className="card" style={{ maxWidth: 720, margin: "3rem auto", textAlign: "center" }}>
      <h2 style={{ fontSize: "2rem", marginBottom: 8 }}>
        🎉 Welcome aboard{ name ? `, ${name.split(" ")[0]}` : "" }!
      </h2>
      <p className="muted" style={{ marginBottom: 18 }}>
        Your seller account is ready. Here’s what happens next:
      </p>

      <ul style={{ textAlign: "left", margin: "0 auto 18px", maxWidth: 500, lineHeight: 1.6 }}>
        <li>Set your first menu and availability</li>
        <li>Upload your kitchen documents</li>
        <li>Get notified when public listings open in your area</li>
      </ul>

      <div className="actions">
        <button className="btn" onClick={() => navigate("/dashboard")}>
          Go to your Seller Dashboard →
        </button>
      </div>
    </section>


    </div>
  </div>



  );
}

